module.exports = __webpack_public_path__ + "static/media/green-triangle.6ad180fc.svg";